import { Navigate, Route, useLocation, useParams } from "react-router-dom";
import { REDIRECT_MAP, resolveRedirect } from "@/lib/redirect-map";

/**
 * Renders a permanent redirect for a legacy path, preserving ?query and #hash
 * so UTM attribution and anchor deep-links are not lost.
 */
function LegacyRedirect() {
  const location = useLocation();
  useParams(); // keeps wildcard matches in sync
  const target =
    resolveRedirect(location.pathname, location.search, location.hash) ?? "/";
  return <Navigate to={target} replace />;
}

/**
 * Route elements generated from the central redirect map.
 * Spread inside <Routes> ABOVE the catch-all "*" route.
 */
export const redirectRoutes = REDIRECT_MAP.flatMap((rule) => {
  const routes = [
    <Route key={rule.from} path={rule.from} element={<LegacyRedirect />} />,
  ];
  if (rule.prefix) {
    routes.push(
      <Route key={`${rule.from}/*`} path={`${rule.from}/*`} element={<LegacyRedirect />} />,
    );
  }
  return routes;
});

export default redirectRoutes;
